/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-22 11:34:28
 * @LastEditors: K
 * @LastEditTime: 2022-09-07 14:50:32
 */
import { Col, Radio, Row } from 'antd';
import { use } from 'echarts';
import React, { ReactElement, useEffect, useState } from 'react';
import { getOrganizationPlaneName } from '../../../models/monitoring';

interface UpdateTimeProps {
  select?: (v: number) => void
  time?: string
  showSelect?: boolean
  titleType?: string
  btnNum?: number
}

export const UpdateTime = ({
  showSelect = true,
  time,
  select,
  titleType,
  btnNum
}: UpdateTimeProps): ReactElement => {

  const [value, setValue] = useState(0)

  useEffect(() => {
    btnNum && setValue(btnNum)
  }, [])

  const getOptions = (v?: string): any => {
    let options = []
    if (v == 'f') {
      options = [
        { label: '省', value: 0 },
        { label: '市', value: 1 },
        { label: '区县', value: 2 },
      ]
    } else if (v == 'g') {
      options = [
        { label: '分布图', value: 0 },
        { label: '分布表', value: 1 },
      ]
    } else if (v == 'addedServices') {
      options = [
        { label: '开通机构', value: 6 },
        { label: '服务笔数', value: 5 },
      ];
    } else if (v == 'addedServicesOperating') {
      options = [
        { label: '运营金额', value: 7 },
        { label: '运营笔数', value: 8 },
      ];
    } else {
      options = [
        { label: '全部', value: 0 },
        { label: '好医点', value: 1 },
        { label: '聚网', value: 2 },
      ];
    }
    return options
  }

  return (
    <Row justify='space-between' align='middle' style={{
      marginBottom: 10
    }}>
      <Col>
        {
          titleType ? (
            <span style={{
              fontSize: 20,
              fontWeight: 600,
            }}>
              {getOrganizationPlaneName(titleType)}
            </span>
          ) : time ? ` 数据更新时间：${time}` : ''
        }

      </Col>
      {
        showSelect ? (
          <Col>
            <Radio.Group options={getOptions(titleType)} onChange={(v) => {
              const value = v.target.value
              setValue(value)
              select && select(value)
            }} value={value}
              optionType="button"
              buttonStyle="solid"
            />
          </Col>
        ) : ''
      }

    </Row>
  );
}

